import styles from './Header.module.sass';
import LogoIcon_SVG from "@/components/svg/Global/LogoIcon_SVG";
import cn from "classnames";
import BurgerMenuButton from "@/components/Header/BurgerMenu/BurgerMenuButton";
import BurgerMenuContent from "@/components/Header/BurgerMenu/BurgerMenuContent";
import {useState} from "react";

const Header = () => {

	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<header className={cn(styles.header, 'header')}>
			<div className={cn(styles.header__container, 'header__container')}>
				{/*Mobile Logo*/}
				<LogoIcon_SVG className={styles.logo}/>

				{/*BurgerMenu*/}
				<BurgerMenuButton className={styles.burger_button} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen}/>
				<BurgerMenuContent className={styles.burger_content} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen}/>

			</div>
		</header>
	);
}
export default Header;